import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';
// import Header from 'gi-happy-header/ssr/header';
import {fetchUserDetailsThunk} from '@stencil/user-reducer';
import {Header} from "@growth/dweb-header";
class HeaderWrapper extends React.Component {
  componentDidMount() {
    const {fetchUserDetails} = this.props;
    fetchUserDetails();
  }

  render() {
    const {
      isHeaderSticky,
      fetchUserDetails,
    } = this.props;


    return (
      <Fragment>
        <Helmet
          link={[
            {
              href: 'https://goibibo.ibcdn.com/styleguide/css/combinedStyles.css',
              rel: 'stylesheet',
              type: 'text/css',
              media: 'all',
            },
            {
              href: 'https://jsak.goibibo.com/pwa_v3/happy-header/8.0.0/ssr/header.css',
              rel: 'stylesheet',
              type: 'text/css',
              media: 'all',
            },
          ]}
        />
        {/* <Header.HappyHeader
          lobName="bus"
          onLoginSuccess={() => {
            fetchUserDetails();
       //     window.location.reload();
            console.log('login successfull');
          }}
          onLogoutSuccess={() => {
            fetchUserDetails();
      //      window.location.reload()
            console.log('logout successfull');
          }}
          sticky={isHeaderSticky}
        /> */}
        <Header
          lobName="bus"
          onLoginSuccess={() => {
            console.log('login successfull')
            fetchUserDetails();
          }}
          onLogoutSuccess={() => {
            fetchUserDetails();
            console.log('logout successfull')
          }}
          sticky={isHeaderSticky}
        />

      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {user} = state;
  const {gocashInfo, userInfo, showLoginPopup} = user;
  return {
    gocashInfo,
    userInfo,
    showLoginPopUp: showLoginPopup || true,
    showGobiz: false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchUserDetails: () => dispatch(fetchUserDetailsThunk()),
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(HeaderWrapper);
